import React, { Fragment } from 'react'

const About = () => {
	return (
		<Fragment>
			<h1>About this App</h1>
			<p>React App to Search Github Users</p>
			<p>
				<em>React Front to Back</em> course project
			</p>
			<p>Version 0.2.0</p>
			<p>Deployed on Netlify</p>
			<p>Taylor Dye, 5/2020</p>
		</Fragment>
	)
}

export default About
